import { useState } from 'react';
import { deleteOrdenCompra } from '../../helpers/api_helper';

const useDeleteOrdenCompra = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteOrdenCompraHook = async (claemp, nroodc) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deleteOrdenCompra(claemp, nroodc);
            return response;
        } catch (err) {
            const errorMessage = `Failed to delete orden compra: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { deleteOrdenCompra: deleteOrdenCompraHook, loading, error };
};

export default useDeleteOrdenCompra;